<div class="split-wrapper">
    <div class="left-side">
      <div class="content">
        <ng-content select="[left]"></ng-content>
      </div>
    </div>
    <div class="right-side">
      <div class="content">
        <ng-content select="[right]"></ng-content>
      </div>
    </div>
  </div>